import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import { UniversityAction } from "../../store/actions";

import {
  Modal,
  Spacer,
  inputFields,
  boxContainer,
  Loader,
  Buttons,
} from "../../components";
import { Utils, Images } from "../../config";

import "./styles.css";

const Compare = () => {
  const dispatch = useDispatch();

  const compareUnis = useSelector(
    (state) => state?.university?.compareUniversity
  );
  const { allUniversities, isLoading } = useSelector(
    (state) => state.university
  );

  const [showModal, setShowModal] = useState(false);
  const [uniIdArray, setUniIdArray] = useState([]);
  const [allUniList, setAllUniList] = useState([]);
  const [modalUni, setModalUni] = useState(null);

  useEffect(() => {
    if (allUniversities?.length === 0) {
      dispatch(UniversityAction.getAllUniversities());
    }
  }, []);

  useEffect(() => {
    const filteredUnis = allUniversities?.map((university) => ({
      label: university.name,
      value: university.id,
    }));
    setAllUniList(filteredUnis);
  }, [allUniversities]);

  useEffect(() => {
    const initialUniIds = compareUnis.map((item) => item.id);
    setUniIdArray(initialUniIds);
  }, []);

  useEffect(() => {
    uniCompareAPICall();
  }, [uniIdArray]);

  const handleUniIdArray = () => {
    setUniIdArray([...uniIdArray, modalUni]);
    setModalUni(null);
  };
  const uniCompareAPICall = async () => {
    const payload = {
      uniIds: uniIdArray,
    };
    dispatch(UniversityAction.compareUniverities(payload));
  };

  const removeUnis = async (uniId) => {
    const filteredUniIds = uniIdArray.filter((id) => id !== uniId);

    setUniIdArray(filteredUniIds);
  };

  const tableHeader = [
    "University Name",
    "Location",
    "QS World Ranking",
    "Average Fee",
    "Acceptance Rate",
    "Average Course Duration",
    "University Type",
    "Total Students",
    "SAT Midrange",
    "ACT Midrange",
    "IELTS Requirements",
    "TOEFL Requirements",
    "Application Deadline",
  ];

  const compareValues = (university) => {
    return [
      { id: 1, value: university?.name },
      {
        id: 2,
        value: `${university?.city ? university?.city : ""}${
          university?.state ? `, ${university?.state}` : ""
        }${university?.country?.name ? `, ${university?.country.name}` : ""}`,
      },
      { id: 3, value: university?.rankings?.QS ?? "N/A" },
      {
        id: 4,
        value: university?.avgFeesUSD
          ? `USD ${university?.avgFeesUSD?.toLocaleString()}`
          : "NA",
      },
      {
        id: 5,
        value: university?.acceptanceRate
          ? `${(university?.acceptanceRate * 100).toFixed(1)}%`
          : "N/A",
      },
      {
        id: 6,
        value: `${university?.courseDuration} 
              ${
                university?.courseDuration
                  ? university?.courseDuration?.includes("Years")
                    ? null
                    : "Years"
                  : "N/A"
              }`,
      },
      { id: 7, value: university?.Type?.type ?? "N/A" },
      { id: 8, value: university?.totalStudents ?? "N/A" },
      {
        id: 9,
        value: university?.testScores?.SATMidrange ?? "N/A",
      },
      { id: 10, value: university?.testScores?.ACTMidrange ?? "N/A" },
      { id: 11, value: university?.requirements?.IELTS ?? "N/A" },
      { id: 12, value: university?.requirements?.TOEFL ?? "N/A" },
      {
        id: 13,
        value: (
          <div className="flex flex-col">
            {university?.appDeadline ? (
              <div className="font-bold rounded-md bg-liteBoxBg border border-main px-2 py-1">
                {moment(university?.appDeadline).format("DD MMMM, YYYY")}
              </div>
            ) : (
              <div className="font-bold ">N/A</div>
            )}
          </div>
        ),
      },
    ];
  };

  return (
    <div className="text-black">
      {isLoading ? (
        <Loader.Circular />
      ) : (
        <boxContainer.LiteBoxContainer>
          <boxContainer.LiteBoxContainer addstyle="py-2">
            {/* top part start */}
            <div className="compare-top-boxes-container">
              <div className="compare-top-boxes gap-2">
                <div className="text-main text-[1.375em] font-semibold">
                  Compare Universities
                </div>
                <div className="text-[0.75em] text-gray-500 font-medium">
                  This section shows the overall summary of different
                  universities
                </div>
              </div>

              {compareUnis?.map((uni, index) => (
                <div
                  className="compare-top-boxes bg-main rounded-xl p-2 relative justify-start pt-[2.5em]"
                  key={index}
                >
                  <div
                    className="absolute top-[2px] right-3 font-medium text-white text-[1.125em] cursor-pointer"
                    onClick={() => removeUnis(uni.id)}
                  >
                    x
                  </div>
                  <div className="flex justify-center items-center">
                    <img
                      src={uni?.profilePic}
                      className="h-[3.5em] w-[3.5em] object-contain rounded-full bg-white p-1"
                    />
                  </div>
                  <div className="text-white font-semibold">{uni?.name}</div>
                </div>
              ))}

              <div
                className="compare-add-more-uni"
                onClick={() => setShowModal(true)}
              >
                <img src={Images.AddUniIcon} />
                <div>Add University</div>
              </div>
            </div>
            {/* top part end */}
          </boxContainer.LiteBoxContainer>
          <Spacer height={20} />
          <div>
            <div className="bg-main rounded-t-[1.875em] text-white font-semibold p-3 flex justify-between items-center">
              AI Generated Results
            </div>
            <div className="compare-table-container">
              <div className="flex w-[calc(100vw-40.625em)] overflow-auto">
                <div className="flex flex-col w-[16.25em]">
                  {tableHeader.map((header, index) => (
                    <div
                      key={index}
                      className="compare-table-value font-bold flex gap-2"
                    >
                      <div className="border-r-[1px] w-[1.875em] border-r-liteBoxBorder py-3 px-2">
                        {index + 1}
                      </div>
                      <div className="py-3 px-2 text-left">{header}</div>
                    </div>
                  ))}
                </div>

                {compareUnis?.map((university, index) => {
                  const values = compareValues(university);
                  return (
                    <div key={index} className="w-[18.125em]">
                      {values?.map((item, index) => (
                        <div key={index} className="compare-table-value">
                          <div className="py-3 px-2 w-full">{item?.value}</div>
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>
              <Spacer height={10} />
              <div className="flex justify-end gap-3">
                <Buttons.DefaultButton size="medium">
                  Download PDF
                </Buttons.DefaultButton>
                <Buttons.DefaultButton
                  size="medium"
                  onClick={() => window.history.back()}
                >
                  Main Menu
                </Buttons.DefaultButton>
              </div>
              <Spacer height={20} />
            </div>
          </div>
        </boxContainer.LiteBoxContainer>
      )}
      <Modal.DefaultModal open={showModal} onCancel={() => setShowModal(false)}>
        <div className="flex justify-start header-sm text-main">
          Select the University you want to compare
        </div>

        <Spacer height={20} />
        {isLoading ? (
          <Loader.Circular />
        ) : (
          <inputFields.SelectDropdown
            items={allUniList}
            onChange={(e) => {
              setModalUni(e);
            }}
            value={modalUni}
            placeholder="Select a University to compare"
          />
        )}

        <Spacer height={20} />

        <div className="flex justify-center items-center">
          <Buttons.DefaultButton
            onClick={() => {
              handleUniIdArray();
              setShowModal(false);
            }}
          >
            Done
          </Buttons.DefaultButton>
        </div>

        <Spacer height={10} />
      </Modal.DefaultModal>
    </div>
  );
};

export default Compare;
